import React from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {connect} from 'react-redux';
import {goToPage, setTitle, setSelectedSubscriber, setPageBackFromOtp, getSubscribers, pageLoaded} from '../fundialSlice';
import {Container, Col, Row} from 'reactstrap';
import {showAppLoader, hideAppLoader} from '../../../Shared/Loader/LoaderSlice';
import OtpVerificationComponent from '../../../Shared/OtpAuthentication/OtpVerificationComponent';
import {otpOrigin} from 'app/Components/Block/OTPLoginBlock/Assets/variables';

const OtpPage = (props) => {
  const otpTitles = {
    verifyPhoneTitle: 'הזינו את מספר המנוי עליו תרצו את שרות המתנה נעימה',
    verifyPhoneDescription: '',
    verifyCodeTitle: 'הזינו את הקוד שקיבלתם',
    verifyCodeDescription: '',
  };

  useExtendedEffect((runSideEffects) => {
    window.scrollTo(0, 0);
    props.setTitle({titleBold: 'המתנה נעימה', titleRegular: ''});

    if (!runSideEffects()) {
      props.goToPage({page: 'lobbyPage'});
    }

    return () => {
      props.setPageBackFromOtp({pageBackFromOtp: null});
    };
  }, []);

  const handleLoginOtpSuccess = (e) => {
    getSubscribers();
  };

  async function getSubscribers() {
    let data = await props.getSubscribers();
    if (data.payload.errorCode == 0) {
      if (
        props.pageBackFromOtp &&
        props.pageBackFromOtp == 'personalAreaPage' &&
        data.payload.results.subscribers[0].fundialSubscriberStatus == 'UNREGISTERED'
      ) {
        props.goToPage({page: 'lobbyPage'});
      } else {
        if (props.pageBackFromOtp) {
          props.goToPage({page: props.pageBackFromOtp});
        }
      }
    }
  }

  function view() {
    return (
      <Row className='justify-content-md-center'>
        <Col xs='12' sm='12' md='6'>
          <OtpVerificationComponent otpTitles={otpTitles} onAuthenticatedAction={handleLoginOtpSuccess} isInline={false} />
        </Col>
      </Row>
    );
  }

  return <div className='otp-page'>{view()}</div>;
};

const mapStateToProps = (state) => {
  return {
    pageBackFromOtp: state.fundialPage.navigation.pageBackFromOtp,
  };
};

const mapDispatchToProps = {
  setTitle,
  goToPage,
  setSelectedSubscriber,
  setPageBackFromOtp,
  showAppLoader,
  hideAppLoader,
  getSubscribers,
  pageLoaded,
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpPage);
